import React, { useState, useEffect, useRef } from "react";
import "./querythreewheeler.scss";
import Sidebar from "../Sidebar";
import { querylist3wAction, queryCategorylistAction } from "../../actions/queryAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import { searchQueryAction, pageQueryAction } from "../../actions/queryAction";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { dowloadsupportquery3wAction } from "../../actions/exceldownloadAction";
import { notify } from '../../services/notification';
import { constant } from "../../constants/constant";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";


function QueryThreeWheelers() {
  const [startIndex, setStartIndex] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchdata = useSelector((state) => state?.QueryThreeWheelersSearch);
  const pagedata = useSelector((state) => state?.querpage);
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const prevStatus = useRef("");
  const [checkDate, setCheckDate] = useState(null)
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(pagedata?.page || 1);
  const [state, setDataState] = useState({
    status: "",
    fromDate: "",
    toDate: "",
    category: null,
    searchBy: "PGM name",
    pgm_name: "",
    pgm_mobile_number: "",
    ticket_id: "",
    filterByState: "",
    filterByValue: "",
  });

  const [inputValue, setInputValue] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [querylist, setquerylist] = useState([])

  useEffect(() => {
    async function fetchCategories() {
      const response = await dispatch(queryCategorylistAction());
      if (response) {
        setCategories(response?.data?.data);
      }
    }
    fetchCategories();
  }, []);

  const handleCategoryChange = (event) => {
    const value = event.target.value;
    setDataState({
      ...state,
      category: value,
    });
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataState({
      ...state,
      status: value,
    });
  };

  const handleSearchByChange = (evt) => {
    const value = evt.target.value;
    const newState = { ...state };
    newState.pgm_name = '';
    newState.pgm_mobile_number = '';
    newState.ticket_id = '';
    newState.searchBy = value;
    setInputValue('');
    setDataState(newState);
  };

  const handleInputChange = (evt) => {
    const value = evt.target.value;
    setInputValue(value);
    if (state?.searchBy == "PGM name") {
      if (value.length >= 3) {
        const newState = { ...state };
        newState.pgm_name = value;
        newState.pgm_mobile_number = '';
        newState.ticket_id = '';
        setDataState(newState);
      } else if (value.length === 0) {
        setDataState({
          ...state,
          pgm_name: "",
        });
      }
    } else if (state?.searchBy == "Ticket id") {
      if (value.length >= 3) {
        const newState = { ...state };
        newState.pgm_name = '';
        newState.ticket_id = value;
        newState.pgm_mobile_number = '';
        setDataState(newState);
      } else if (value.length === 0) {
        setDataState({
          ...state,
          pgm_mobile_number: "",
        });
      }
    } else {
      if (value.length >= 3) {
        const newState = { ...state };
        newState.pgm_name = '';
        newState.pgm_mobile_number = value;
        newState.ticket_id = '';
        setDataState(newState);
      } else if (value.length === 0) {
        setDataState({
          ...state,
          pgm_mobile_number: "",
        });
      }
    }
  };
  var today = new Date().toISOString().split("T")[0];

  const handleDateChange = (evt) => {
    const { name, value } = evt.target;
    if (!value) {
      setDataState((prevState) => ({
        ...prevState,
        [name]: "",
      }));
      return;
    }

    if (value > today) {
      notify.error("Future dates are not allowed.");
      return;
    }

    if (name === "fromDate") {
      const maxDate = new Date(value);
      maxDate.setDate(maxDate.getDate() + 31);
      setDataState((prevState) => ({
        ...prevState,
        toDate:
          prevState.toDate && new Date(prevState.toDate) > maxDate
            ? ""
            : prevState.toDate,
        [name]: value,
      }));
    } else if (name === "toDate") {
      if (new Date(value) < new Date(state.fromDate)) {
        notify.error("To Date cannot be earlier than From Date.");
        return;
      }
      setDataState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    if (!state.fromDate && !state.toDate) {
      queryList();
    } else if (state.fromDate && state.toDate) {
      queryList();
    }
  }, [state.fromDate, state.toDate]);

  const handlePaginationChange = (event, value) => {
    dispatch(pageQueryAction(value));
    setPage(value);
  };
  useEffect(() => {
    queryList();
  }, [page, state?.filterByValue, state?.filterByState, state?.pgm_mobile_number, state?.pgm_name, state?.ticket_id, state?.status, state?.category]);

  const [count, setCount] = useState(1)

  async function queryList() {
    setLoading(true);
    const newStartIndex = (page - 1) * constant.paginationCount + 1;
    setStartIndex(newStartIndex);
    const response = await dispatch(querylist3wAction(page, state?.status, state?.fromDate, state?.toDate, state?.category, state?.pgm_name, state?.pgm_mobile_number, state?.ticket_id, state?.filterByState, state?.filterByValue));

    if (response?.status === HTTP_STATUS.SUCCESS) {
      const count = response?.data?.data?.count;
      setCount(Math.ceil(count / constant.paginationCount));
      setquerylist(response?.data?.data.results);
      setpaginationListcount(count);
    }
    setLoading(false);
  }

  async function downloadquerylist() {
    try {
      const { fromDate, toDate, status } = state;

      if (!fromDate || !toDate) {
        notify.error('Please select both from and to dates.');
        return;
      }

      const formattedFromDate = new Date(fromDate).toISOString().split('T')[0]; // Format as YYYY-MM-DD
      const formattedToDate = new Date(toDate).toISOString().split('T')[0]; // Format as YYYY-MM-DD
      const fileBlob = await dispatch(dowloadsupportquery3wAction(formattedFromDate, formattedToDate, status));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          notify.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const queryDetails = (Id) => {
    window.scroll(0, 0)
    const encodeid = encode(Id)
    navigate(`/3w/support/viewquery/${encodeid}`);
  };

  const toggleFilter = (value) => {
    if (state?.filterByState) {
      if (state?.filterByState == 'asc') {
        let newState = { ...state };
        newState.filterByState = 'desc';
        newState.filterByValue = value;
        setDataState(newState);
      } else {
        let newState = { ...state };
        newState.filterByState = 'asc';
        newState.filterByValue = value;
        setDataState(newState);
      }
    } else {
      let newState = { ...state };
      newState.filterByState = 'asc';
      newState.filterByValue = value;
      setDataState(newState);
    }
  }

  const [paginationListcount, setpaginationListcount] = useState(0);
  const startItem = querylist?.length > 0 ? (page - 1) * constant.paginationCount + 1 : 0;
  const endItem = querylist?.length > 0 ? Math.min(page * constant.paginationCount, paginationListcount) : 0;
  const displayCount = querylist?.length > 0 ? paginationListcount : 0;


  return (
    <div className="query-list-3w">
      <div className="Query_Containers">
        <div className="Query_Containers_right">
          <Header title="PGM Support Query" />
          {isLoading ? (
            <Loader />
          ) : (
            <div className="Queery_Special">
              <div className="Query-button">
                <div className="Query_Search_button" >
                </div>
                <button className="download_excel" onClick={downloadquerylist}>
                  <img src={Image_Url.EXCEL_LOGO} className="downloads_imgdexcel" />
                  Download Excel
                </button>
              </div>
              <div className="input-dropdown-container" >
                <div className="input-query">
                  <label className="label-text">
                    Select Ticket Creation Date<span className="required">*</span>
                  </label>
                  <div className="from-to-date">
                    <div className="date-container">
                      <label className="date-label">
                        From Date<span className="required">*</span>
                      </label>
                      <div className="date-input">
                        <input
                          type="date"
                          name="fromDate"
                          value={state.fromDate}
                          max={today}
                          onChange={handleDateChange}
                          className="text_field"
                          placeholder={state.fromDate ? "" : "From Date"}
                        />
                        {!(state?.fromDate == '') &&
                          <button onClick={() => setDataState({ ...state, fromDate: '' })}>X</button>
                        }
                      </div>
                    </div>

                    <div className="date-container">
                      <label className="date-label">
                        To Date<span className="required">*</span>
                      </label>
                      <div className="date-input">
                        <input
                          type="date"
                          name="toDate"
                          value={state.toDate}
                          min={state.fromDate}
                          max={today}
                          onChange={handleDateChange}
                          className="text_field"
                          placeholder="To Date"
                        />
                        {!(state?.toDate == '') &&
                          <button onClick={() => setDataState({ ...state, toDate: '' })}>X</button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="input-query">
                  <label className="label-text">
                    Select Problem Category<span className="required">*</span>
                  </label>
                  <select className="text-file-drop-down" onChange={handleCategoryChange} value={state?.category}>
                    <option value="">Select Category</option>
                    {categories?.map((category) => (
                      <option key={category?.id} value={category?.id}>
                        {category?.category}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="input-dropdown-container" >
                <div className="input-query">
                  <div className="from-to-date">
                    <div className="date-container">
                      <label className="date-label">
                        Search By Type<span className="required">*</span>
                      </label>
                      <div className="search-by-type-input">
                        <select name="searchBy" className="text_field" value={state?.searchBy} onChange={handleSearchByChange}>
                          <option value="PGM name">PGM Name</option>
                          <option value="Mobile No.">Mobile No.</option>
                          <option value="Ticket id">Ticket Id.</option>
                        </select>
                      </div>
                    </div>
                    <div className="date-container">
                      <label className="date-label">
                        Search by {state?.searchBy?.length ? state?.searchBy : `PGM name`}<span className="required">*</span>
                      </label>
                      <div className="date-input">
                        <input
                          className="text_field"
                          type="text"
                          name="pgmName"
                          placeholder={state?.searchBy?.length ? state?.searchBy : `PGM name`}
                          value={inputValue}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="input-query">
                  <label className="label-text">
                    Select Ticket Status<span className="required">*</span>
                  </label>
                  <select name="status" id="cars" className="text-file-drop-down status-drop-down" value={state?.status} onChange={handleChange}>
                    <option value="">Status</option>
                    <option value="OPEN">Open</option>
                    <option value="CLOSED">Closed</option>
                  </select>
                </div>
              </div>
              <div className="tabledata">
                <div className="query-table-data">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="tablesth">S.NO.</th>
                        <th className="tablesth query_text">PGM Id</th>
                        <th className="tablesth query_text">Ticket Id</th>
                        <th className="tablesth query_text">PGM Name</th>
                        <th className="tablesth">Mobile No.</th>
                        <th className="tablesth">Dealer ID</th>
                        <th className="tablesth">Dealer Name</th>
                        <th className="tablesth">Query</th>
                        <th className="tablesth">Status</th>
                        <th className="tablesth" onClick={() => toggleFilter('created_at')}>
                          <span>
                            {(state?.filterByState && state?.filterByValue == 'created_at')
                              ? ((state?.filterByState == 'asc') ? '▲' : '▼')
                              : '⥮'
                            }
                          </span>
                          Creation Date
                        </th>
                        <th className="tablesth">Resolution Date</th>
                        <th className="tablesth" onClick={() => toggleFilter('closed_at')}>
                          {(state?.filterByState && state?.filterByValue == 'closed_at')
                            ? ((state?.filterByState == 'asc') ? <span>&#9650;</span> : <span>&#9660;</span>)
                            : <span>&#10606;</span>
                          }
                          Closed Date</th>
                        <th className="tablesth">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {querylist && querylist?.length > 0 ? (
                        querylist?.map((item, i) => (
                          <tr key={item?.id || i}>
                            <td className="tabletd">{i + startIndex}</td>
                            <td className="tabletd">{item.pgm?.id}</td>
                            <td className="tabletd">{item?.id}</td>
                            <td className="tabletd query_text">{item?.pgm?.name}</td>
                            <td className="tabletd ">{item?.pgm?.mobile_number}</td>
                            <td className="tabletd">
                              {item.pgm?.dealers?.map((dealer) => dealer?.dealer_id).join(", ")}
                            </td>
                            <td className="tabletd query_text">
                              {item.pgm?.dealers?.map((dealer) => dealer?.name).join(", ")}
                            </td>
                            <td className="tabletd query_text" title={item?.query}>{item?.query}</td>
                            <td className="tabletd">{item?.status}</td>
                            <td className="tabletd">
                              {new Date(item?.created_at).toLocaleDateString()}
                            </td>
                            <td className="tabletd">
                              {item?.resolution_date
                                ? new Date(item?.resolution_date).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td className="tabletd">
                              {item?.closed_at
                                ? new Date(item?.closed_at).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>
                              <div
                                className="btn view_text"
                                onClick={() => queryDetails(item?.id)}
                              >
                                View
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="no-data-row">
                          <td colSpan="100%">
                            <NoDataFound className="no-data-text" />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="Pagination_section">
                {querylist?.length > 0 && (
                  <Stack spacing={2}>
                    <Pagination
                      count={count}
                      className="pagination"
                      page={page}
                      size="medium"
                      defaultPage={1}
                      color="primary"
                      onChange={handlePaginationChange}
                    />
                  </Stack>
                )}
                <div className="count">
                  <b>
                    <span>
                      {displayCount === 0
                        ? ""
                        : `Displaying ${startItem} to ${endItem} out of ${displayCount}`}
                    </span>
                  </b>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default QueryThreeWheelers;
